import { createPortal } from "react-dom";

/**
 * Rend une fenêtre plein écran (fixed inset-0) directement dans <body>.
 * Sans cela, une fenêtre ouverte depuis une zone qui défile (onglets du carnet) reste
 * enfermée dans cette zone sur iPhone : la barre du bas passe devant ses boutons.
 */
export default function ModalPortal({ children }) {
  if (typeof document === "undefined") return children;
  return createPortal(children, document.body);
}
